import React, { useContext, useEffect, useRef, useState } from 'react'
import useAxiosPrivate from '../hooks/useAxiosPrivate';
import { ENDPOINT_COMPONENT, ENDPOINT_GROUPS } from '../Config';
import { Link, useNavigate } from 'react-router-dom';
import EventContext from '../context/EventProvider';
import usePageTitle from '../hooks/usePageTitle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArchive, faPlusCircle, faUndo, faUser } from '@fortawesome/free-solid-svg-icons';
import useAuth, { useGetFeatureCreateNewEvent } from '../hooks/useAuth';
import { format } from 'date-fns';
import { faClock, faEdit } from '@fortawesome/free-regular-svg-icons';
import eventTypes from "../data/event_types.json";
import BillingFeatureCTA from '../components/BillingFeatureCTA';
import { Modal } from 'bootstrap';

const Groups = () => {
    usePageTitle('Campaigns');
    const axiosPrivate = useAxiosPrivate();
    const navigate = useNavigate();
    const eventModalRef = useRef();
    let eventModal = null;
    const [loading, setLoading] = useState(false);
    const [eventLoading, setEventLoading] = useState(false);
    const [includeArchived, setIncludeArchived] = useState(false);
    const [groups, setGroups] = useState([]);
    const [filteredGroups, setFilteredGroups] = useState(null);
    const [editGroup, setEditGroup] = useState(null);
    const [error, setError] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const { auth } = useAuth();
    const { switchGroup } = useContext(EventContext);
    const featureCreateNewEvent = useGetFeatureCreateNewEvent();
    const goToGroup = (groupId) => {
        switchGroup(groupId);
        navigate(`/group/${groupId}/frame`);
    }
    const load = async () => {
        try {
            setLoading(true);
            const response = await axiosPrivate.get(ENDPOINT_GROUPS + (includeArchived ? '?archived' : ''));
            let accountGroups = response.data;
            if (accountGroups) {
                accountGroups = accountGroups.map(item => {
                    let { name, ...rest } = item;
                    return { eventName: name, ...rest };
                });
                setGroups(accountGroups);
                setFilteredGroups(accountGroups);
                if (Array.isArray(accountGroups)) {
                    if (accountGroups.length === 1) {
                        // there is only one group
                        //goToGroup(groups[0].id);
                    }
                }
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const handleCreateAndEdit = async (group) => {
        setError('');
        if (!eventModal) {
            eventModal = new Modal(eventModalRef.current, {
                keyboard: false,
                backdrop: 'static'
            });
        }
        eventModal.show();
        if (!group) {
            // Create new handler
            setEditGroup({
                eventName: '',
                eventType: eventTypes[0].value
            });
            return;
        }
        // Editing handler
        if (!group.eventType) {
            // Load eventType if it is not assigned to the selected event
            setEventLoading(true);
            const response = await axiosPrivate.get(ENDPOINT_COMPONENT.replace('{groupId}', group.id), {});
            group.eventType = response.data.eventType;
            setEventLoading(false);
        }
        setEditGroup(group);
    };

    const handleArchive = (group) => {
        setEditGroup(group);
    };

    const handleSave = async (e) => {
        e.preventDefault();
        if (editGroup.eventName.trim() === '') {
            setError('Campaign Name is required.');
            return;
        }
        setError('');
        document.querySelector('#EventModalClose').click();
        try {
            setLoading(true);
            const response = await axiosPrivate({
                method: editGroup?.id ? 'put' : 'post',
                url: editGroup?.id ? `${ENDPOINT_GROUPS}/${editGroup.id}` : ENDPOINT_GROUPS,
                data: editGroup
            });
            if (response.status === 201) {
                // Create callback
                const { name, ...rest } = response.data;
                const newGroup = {
                    ...rest,
                    eventName: name
                };
                setGroups([newGroup, ...groups]);
            } else if (response.status === 202) {
                // Updated callback
                setGroups((prevGroups) => {
                    return prevGroups.map((c) => {
                        if (editGroup.id === c.id) {
                            return { ...c, ...editGroup };
                        } else {
                            return c;
                        }
                    });
                });
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const updateStatus = async (group, status) => {
        try {
            setLoading(true);
            const response = await axiosPrivate({
                method: 'put',
                url: `${ENDPOINT_GROUPS}/${group.id}/${status}`
            });
            if (response.status === 202) {
                setGroups((prevList) =>
                    prevList.map((item) =>
                        item.id === group.id ? { ...item, archived: status === 'archive' } : item
                    )
                );
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (groups) {
            setFilteredGroups(groups.filter(group =>
                group.eventName.toLowerCase().includes(searchQuery.toLowerCase()) ||
                group?.creator?.firstName.toLowerCase().includes(searchQuery.toLowerCase()) ||
                group?.creator?.lastName.toLowerCase().includes(searchQuery.toLowerCase()) ||
                group?.creator?.email.toLowerCase().includes(searchQuery.toLowerCase())
            ));
        }
    }, [searchQuery, groups]);

    useEffect(() => {
        load();
    }, [includeArchived]);

    return (
        <section>
            <div className="row d-flex justify-content-center">
                <div className="col-7">
                    <div className=''>
                        <div className='d-flex flex-row justify-content-between align-items-center'>
                            <h1>Campaigns</h1>
                            {auth.account.Role !== 'SUPER_ADMIN' &&
                                <>
                                    {groups.length === 0 &&
                                        <button className='btn btn-primary' type='button' onClick={(e) => { handleCreateAndEdit(null) }}><FontAwesomeIcon icon={faPlusCircle} fixedWidth /> Create New Campaign</button>
                                    }
                                    {groups.length > 0 &&
                                        <BillingFeatureCTA feature={featureCreateNewEvent} type='button' onClick={(e) => { handleCreateAndEdit(null) }}><FontAwesomeIcon icon={faPlusCircle} fixedWidth /> Create New Campaign</BillingFeatureCTA>
                                    }
                                </>
                            }
                            {auth.account.Role === 'SUPER_ADMIN' &&
                                <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" disabled={loading} checked={!includeArchived}
                                        onChange={() => {
                                            setIncludeArchived(!includeArchived);
                                        }} />
                                    <label className="form-check-label" htmlFor="flexSwitchCheckChecked">Hide Archived Campaign</label>
                                </div>
                            }
                        </div>
                        <hr />
                        {!loading && groups.length > 0 && auth.account.Role === 'SUPER_ADMIN' &&
                            <div className='pb-3'>
                                <input type='text' value={searchQuery} className='form-control form-control-lg bg-light shadow-none' placeholder='Search' onChange={(e) => setSearchQuery(e.target.value)} />
                            </div>
                        }
                    </div>
                    {loading ?
                        <>
                            <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                            <span role="status"> Please wait...</span>
                        </>
                        :
                        <>
                            {groups && groups.length > 0 &&
                                <div className="vstack gap-3">
                                    {filteredGroups.map(item => (
                                        <div key={item.id} className="hstack gap-1 align-items-start">
                                            <div className='flex-grow-1'>
                                                <div className={`card p-3 flex-row justify-content-between ${item.archived ? 'text-muted' : ''}`}>
                                                    <div className='flex-grow-1'>
                                                        <div className="text-break">
                                                            {item.eventName}
                                                            {item.archived &&
                                                                <span className="badge rounded-pill text-bg-light text-muted ms-2">Archived</span>
                                                            }
                                                        </div>
                                                        {item?.creator &&
                                                            <div className='small text-muted'>
                                                                Created by: {item.creator?.firstName} <small>{item.creator?.lastName} &lt;{item.creator?.email}&gt;</small>
                                                            </div>
                                                        }
                                                    </div>
                                                    <div className='small text-nowrap ms-2'>
                                                        <div>
                                                            <span className='text-muted'><FontAwesomeIcon icon={faClock} /> Created on: </span><span>{format(new Date(item.ctime), "MM/dd/yyyy")}</span>
                                                        </div>
                                                    </div>
                                                    {!item.archived &&
                                                        <a href={`/group/${item.id}/frame`} className='stretched-link'></a>
                                                    }
                                                </div>
                                            </div>
                                            <button type='button me-1' disabled={item.archived} className='btn btn-outline-dark border-0' onClick={(e) => { handleCreateAndEdit(item) }}><FontAwesomeIcon icon={faEdit} className='d-block mx-auto mb-1' />Edit</button>
                                            {item.archived &&
                                                <button type='button me-1' className='btn btn-outline-dark border-0'
                                                    style={{ minWidth: '100px' }}
                                                    onClick={() => {
                                                        updateStatus(item, 'unarchive')
                                                    }}
                                                ><FontAwesomeIcon icon={faUndo} className='d-block mx-auto mb-1' />Unarchive</button>
                                            }
                                            {!item.archived &&
                                                <button type='button me-1' className='btn btn-outline-dark border-0' data-bs-toggle="modal" data-bs-target="#ArchiveModal"
                                                    style={{ minWidth: '100px' }}
                                                    onClick={() => {
                                                        handleArchive(item)
                                                    }}
                                                ><FontAwesomeIcon icon={faArchive} className='d-block mx-auto mb-1' />Archive</button>
                                            }
                                        </div>
                                    ))}
                                </div>
                            }
                        </>
                    }
                </div>
            </div>
            <div ref={eventModalRef} className="modal fade">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        {editGroup &&
                            <>
                                {eventLoading ?
                                    <div className="modal-body">
                                        <span className="spinner-grow spinner-grow-sm" aria-hidden="true"></span>
                                        <span role="status"> Loading...</span>
                                    </div>
                                    :
                                    <form onSubmit={handleSave}>
                                        <div className="modal-header">
                                            <h1 className="modal-title fs-5">{editGroup?.id ? 'Edit' : 'Create New'} Campaign</h1>
                                            <button id="EventModalClose" type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                        </div>
                                        <div className="modal-body">
                                            {error &&
                                                <div className='alert alert-danger'>
                                                    {error}
                                                </div>
                                            }
                                            <div className='mb-3'>
                                                <label htmlFor='eventName'>
                                                    Campaign Name:
                                                </label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    id="eventName"
                                                    maxLength="200"
                                                    onChange={(e) => setEditGroup((prev) => ({
                                                        ...prev,
                                                        eventName: e.target.value
                                                    }))}
                                                    value={editGroup.eventName}
                                                    required
                                                />
                                            </div>
                                            <div className='mb-3'>
                                                <label htmlFor='eventType'>
                                                    What are you trying to promote with VideoBoost?
                                                </label>
                                                <select
                                                    id="eventType"
                                                    className="form-select"
                                                    value={editGroup.eventType}
                                                    onChange={(e) => setEditGroup((prev) => ({
                                                        ...prev,
                                                        eventType: e.target.value
                                                    }))}>
                                                    {eventTypes.map((eventType, i) => (
                                                        <React.Fragment key={i}>
                                                            <option value={eventType.value}>{eventType.name}</option>
                                                        </React.Fragment>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="modal-footer">
                                            <button type='submit' className='btn btn-primary'>{editGroup?.id ? 'Update' : 'Create'} Campaign</button>
                                        </div>
                                    </form>
                                }
                            </>
                        }
                    </div>
                </div>
            </div>
            <div className="modal fade" id="ArchiveModal" data-bs-backdrop="static" data-bs-keyboard="false">
                <div className="modal-dialog modal-dialog-centered">
                    {editGroup &&
                        <div className="modal-content">
                            <div className="modal-body">
                                <p>
                                    Are you sure you want to archive the "<strong className="text-break">{editGroup.eventName}</strong>" campaign?
                                </p>
                                This will archive all videos and the gallery under this campaign.
                            </div>
                            <div className="modal-footer">
                                <button type='button' className='btn btn-outline-dark' data-bs-dismiss="modal" onClick={() => { setEditGroup(null) }}>Cancel</button>
                                <button type='button' className='btn btn-danger' data-bs-dismiss="modal" onClick={() => { updateStatus(editGroup, 'archive') }}>Archive</button>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </section>
    )
}

export default Groups
